export const FREQUENCY_ONCE = 'once'
export const FREQUENCY_MINUTE = 'minute'
export const FREQUENCY_HOURS = 'hour'
export const FREQUENCY_DAYS = 'day'
export const FREQUENCY_MONTHS = 'month'

export const DEFAULT_DURATION = 1
